import { memo, useState } from 'react'
import UserInfoModal from '../modal/UserInfoModal'
import AddCarModal from '../modal/AddCarModal'

function AddModalMoreButton({ customers, cars, setCars, customer_types, car_models }) {
  const [newCar, setShowModal] = useState(false)
  const [userResult, setUserResult] = useState(false)
  const [customer, setCustomer] = useState({})

  const addNewCar = () => {
    setShowModal(true)
  }

  return (
    <>
      <button
        type={'button'}
        onClick={addNewCar}
        className="w-full md:w-fit shadow-add-more h-11 mx-auto px-5 py-2.5 text-md font-medium text-white
                flex items-center justify-center bg-blue rounded-md hover:bg-link
                transition-all duration-300 ease-linear whitespace-nowrap"
      >
        <span className={'text-white pl-2'}>ثبت خودروی جدید</span>
        <i className={'icon-add text-white'} />
      </button>

      {newCar && (
        <UserInfoModal
          customers={customers}
          setShowModal={setShowModal}
          customer_types={customer_types}
          setUserResult={setUserResult}
          setCustomer={setCustomer}
        />
      )}

      {userResult && (
        <AddCarModal
          cars={cars}
          setCars={setCars}
          customer={customer}
          car_models={car_models}
          setUserResult={setUserResult}
        />
      )}
    </>
  )
}

export default memo(AddModalMoreButton)
